"use client";

import { useState, useEffect } from "react";

export function MobileMenuButton({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);

  // Close menu on any navigation (URL change)
  useEffect(() => {
    const handleNav = () => setOpen(false);

    // Listen for popstate (back/forward) and click on links
    window.addEventListener("popstate", handleNav);

    // Also observe URL changes via a MutationObserver on the title (RSC updates the title)
    const observer = new MutationObserver(handleNav);
    const title = document.querySelector("title");
    if (title) {
      observer.observe(title, { childList: true });
    }

    return () => {
      window.removeEventListener("popstate", handleNav);
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="md:hidden flex flex-col justify-center items-center w-9 h-9 gap-[5px] rounded"
        aria-label="Toggle menu"
      >
        <span className={`block w-5 h-[2px] bg-chocolate transition-all duration-200 ${open ? "rotate-45 translate-y-[7px]" : ""}`} />
        <span className={`block w-5 h-[2px] bg-chocolate transition-all duration-200 ${open ? "opacity-0" : ""}`} />
        <span className={`block w-5 h-[2px] bg-chocolate transition-all duration-200 ${open ? "-rotate-45 -translate-y-[7px]" : ""}`} />
      </button>

      {open && (
        <div className="md:hidden absolute top-full left-0 w-full bg-white border-b border-silver/20 shadow-lg z-50">
          <nav
            className="flex flex-col px-6 py-4 gap-4 font-sans text-base font-medium text-chocolate"
            onClick={() => setOpen(false)}
          >
            {children}
          </nav>
        </div>
      )}
    </>
  );
}
